// Date/time formats for list views (Visits, Service Requests).
//
// Lists use a weekday-first, month-name format ("Thu 26 Jun 2026 12:00") rather than an
// all-numeric one ("26/06/2026 12:00"): the weekday and the spelled-out month make a row
// much faster to scan and easier to hold in memory when comparing dates across rows.
//
// Both parts are plain dayjs tokens, so the weekday and month names come from whichever
// dayjs locale is active — "Thu 26 Jun" in English, "Πεμ 26 Ιουν" in Greek — with no
// per-language format string needed.
export const LIST_DATE_FORMAT = 'ddd D MMM YYYY';

export const LIST_TIME_FORMAT = 'HH:mm';
